import axios from 'axios'
import * as ConstantsBase from '../Constants/base'
import { environmentConfig } from '../Utility/Utility'

export const Authentication = (AuthData) => {
      const getUrl = environmentConfig();
     const requestUrl = getUrl+ConstantsBase.VendorLogin

     try {
      const data =  axios({
        method: 'post',
        url: requestUrl,
        data: AuthData,
        headers: { 'Content-Type': 'application/json;' },
        validateStatus: function (status) { return status >= 200 }
      })
      return data
     }
     catch (e) {
      return e;
    }
}